(function () {
  'use strict';

  // The UpCart custom Hat Tracker already exposes a debounced refresh method,
  // but its current app-admin script also wraps fetch('/cart.js'), observes the
  // entire document and starts a 1.5-second interval. A refresh then schedules
  // another refresh, creating a request loop. Prevent those three mechanisms
  // before the app script runs; cart events below are the single refresh source.
  window.__egHatTrackerFetchWrapped = true;

  var trackerTimer = null;
  var trackerObserver = null;
  var refreshTimer = null;

  try {
    Object.defineProperty(window, '__egHatTrackerTimer', {
      configurable: true,
      get: function () { return trackerTimer; },
      set: function (value) {
        if (value) window.clearInterval(value);
        trackerTimer = null;
      }
    });

    Object.defineProperty(window, '__egHatTrackerObserver', {
      configurable: true,
      get: function () { return trackerObserver; },
      set: function (value) {
        trackerObserver = value || null;
        if (value && typeof value.disconnect === 'function') {
          window.setTimeout(function () {
            value.disconnect();
            if (trackerObserver === value) trackerObserver = null;
          }, 0);
        }
      }
    });
  } catch (error) {
    // Older browsers can reject a property definition. Keep the event-based
    // refresh path active even when the defensive cleanup is unavailable.
  }

  function refreshHatTracker() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      if (typeof window.__egHatTrackerRefresh === 'function') {
        window.__egHatTrackerRefresh();
      }
    }, 250);
  }

  [
    'aftersell-upcart:public-events:cart-loaded',
    'aftersell-upcart:public-events:cart-updated',
    'cart:item-added',
    'cart:updated'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, refreshHatTracker);
  });

  window.addEventListener('pageshow', refreshHatTracker, { once: true });
})();
